import Vue from 'vue';
var ThePlayerBus = new Vue();
export default ThePlayerBus;



//////////////////
// WEBPACK FOOTER
// ./src/EventBuses/ThePlayerEventBus.ts
// module id = 16
// module chunks = 0